import React from 'react';
import SvgIcon48 from '../svgIcon48';

/* eslint-disable max-len */
/* eslint-disable react/self-closing-comp */

const TelIcon = ({ ...others }) => (
  <SvgIcon48
    title="icons / cat / tel"
    {...others}
  >
    <path d="M33.4285714,5.625 C33.9216828,5.625 34.3214286,6.01675084 34.3214286,6.5 L34.3214286,41.5 C34.3214286,41.9832492 33.9216828,42.375 33.4285714,42.375 L15.5714286,42.375 C15.0783172,42.375 14.6785714,41.9832492 14.6785714,41.5 L14.6785714,6.5 C14.6785714,6.01675084 15.0783172,5.625 15.5714286,5.625 L33.4285714,5.625 L33.4285714,5.625 Z M33.4285714,3 L15.5714286,3 C13.598983,3 12,4.56700338 12,6.5 L12,41.5 C12,43.4329966 13.598983,45 15.5714286,45 L33.4285714,45 C35.401017,45 37,43.4329966 37,41.5 L37,6.5 C37,4.56700338 35.401017,3 33.4285714,3 Z" id="Shape"></path>
    <rect id="Rectangle-path" x="13.7053571" y="35.585" width="21.5982143" height="2.625"></rect>
    <rect id="Rectangle-path" x="21.2946429" y="38.98" width="6.41964286" height="2.625" rx="1.3125"></rect>
  </SvgIcon48>
);

export default TelIcon;
